var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "transfer-apply-dialog" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialogNew",
          attrs: {
            visible: _vm.configVo.dialog,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.cancel,
            title: _vm.operationName,
            width: "460px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.configVo, "dialog", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPage === 1,
                  expression: "showPage === 1"
                }
              ]
            },
            [
              _c(
                "el-form",
                {
                  ref: "firstForm",
                  staticClass: "edit-class-form",
                  attrs: {
                    model: _vm.firstForm,
                    rules: _vm.firstFormRules,
                    autocomplete: "off",
                    "label-position": "right",
                    "label-width": "100px"
                  }
                },
                [
                  _c("el-form-item", { attrs: { "label-width": "0" } }, [
                    _vm._v("第一步：填写转校生信息")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "学籍号：", prop: "sid" } },
                    [
                      _c("el-input", {
                        ref: "sid",
                        attrs: {
                          placeholder: "请输入学籍号",
                          name: "name",
                          tabindex: "2",
                          autocomplete: "off"
                        },
                        model: {
                          value: _vm.firstForm.sid,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.firstForm,
                              "sid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "firstForm.sid"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "学生姓名：", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          "auto-complete": "off",
                          placeholder: "请输入学生姓名",
                          maxlength: 50
                        },
                        model: {
                          value: _vm.firstForm.name,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.firstForm,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "firstForm.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "学生性别：", prop: "sex" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择性别" },
                          model: {
                            value: _vm.firstForm.sex,
                            callback: function($$v) {
                              _vm.$set(_vm.firstForm, "sex", $$v)
                            },
                            expression: "firstForm.sex"
                          }
                        },
                        _vm._l(_vm.sexList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.text, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-layout-center" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "min-btn len134",
                      attrs: { type: "primary" },
                      on: { click: _vm.nextStepFirstFn }
                    },
                    [_vm._v("下一步")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPage === 2,
                  expression: "showPage === 2"
                }
              ]
            },
            [
              _c("ul", { staticClass: "confirm-info" }, [
                _c("li", [_vm._v("第二步：请确认该学生原有学校的信息")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("\n          转出学校：\n          "),
                  _c("span", [_vm._v(_vm._s(_vm.secondForm.orgName))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("\n          转出学校当前学期：\n          "),
                  _c("span", [_vm._v(_vm._s(_vm.secondForm.termSettingName))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("\n          年级：\n          "),
                  _c("span", { staticClass: "grade-name" }, [
                    _vm._v(_vm._s(_vm.secondForm.gradeName))
                  ]),
                  _vm._v("\n          班级：\n          "),
                  _c("span", [_vm._v(_vm._s(_vm.secondForm.className))])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-layout-center" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "min-btn len134",
                      on: { click: _vm.PrevStepSecondFn }
                    },
                    [_vm._v("上一步")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "min-btn len134",
                      attrs: { type: "primary" },
                      on: { click: _vm.nextStepSecondFn }
                    },
                    [_vm._v("确认并下一步")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPage === 3,
                  expression: "showPage === 3"
                }
              ]
            },
            [
              _c(
                "el-form",
                {
                  ref: "thirdForm",
                  staticClass: "edit-class-form",
                  attrs: {
                    model: _vm.thirdForm,
                    rules: _vm.thirdFormRules,
                    autocomplete: "off",
                    "label-position": "right",
                    "label-width": "100px"
                  }
                },
                [
                  _c("el-form-item", { attrs: { "label-width": "0" } }, [
                    _vm._v("第三步：请填写该学生在本学校的信息")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "name", "label-width": "0" } },
                    [
                      _vm._v("\n          转入学校当前学期：\n          "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.thirdForm.nowUserTermSettingName))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "转入年级：", prop: "gradeId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.gradeFn },
                          model: {
                            value: _vm.thirdForm.gradeId,
                            callback: function($$v) {
                              _vm.$set(_vm.thirdForm, "gradeId", $$v)
                            },
                            expression: "thirdForm.gradeId"
                          }
                        },
                        _vm._l(_vm.gradeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "转入班级：", prop: "classId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.thirdForm.classId,
                            callback: function($$v) {
                              _vm.$set(_vm.thirdForm, "classId", $$v)
                            },
                            expression: "thirdForm.classId"
                          }
                        },
                        _vm._l(_vm.classList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-layout-center" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "min-btn len134",
                      on: { click: _vm.PrevStepThirdFn }
                    },
                    [_vm._v("上一步")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "min-btn len134",
                      attrs: { type: "primary" },
                      on: { click: _vm.nextStepThirdFn }
                    },
                    [_vm._v("确认转学")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }